export default {
  'title.doctor': 'Врачам',
  'title.patient': 'Пациентам',

  'header.search': 'Поиск',

  'mainNav.professionals': 'Врачам',
  'mainNav.patients': 'Пациентам',
  'mainNav.partners': 'Партнерам',
  'mainNav.service': 'Сервис',
  'mainNav.questions': 'Вопросы и ответы',

  'footerNav.privacyPolicy': 'Privacy Policy',
  'footerNav.termsOfUse': 'Terms of Use',

  'productDrawer.tabs.overview': 'Обзор',
  'productDrawer.tabs.indications': 'Предписания',
  'productDrawer.tabs.techSpecs': 'Технические характеристики',
}



// WEBPACK FOOTER //
// ./src/intl/ru.js